import { Branch } from './branch';
import { Category } from './category';

export class Partner {
  Id: number;
  Name: string;
  Image: string;
  Branches: Branch[];
  Category: Category;
}


export class PartnersList
{
  id :string;
  data : Partner[];
  count:number;
  appliedFilters:string
}
